// extracted by css-extract-rspack-plugin
export default {"hoverBackground":"_9541e8b","active":"_f6b0bd8f","linkItem":"_7fd53096"};